import React from "react";
import {
  Button,
  Col,
  Grid,
  Row,
  Table,
  FormGroup,
  ControlLabel,
  FormControl,
  Clearfix,
  Modal,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import NotificationSystem from "react-notification-system";
import Card from "components/Card/Card";
import { useState, useEffect, useRef } from "react";
import Datetime from "react-datetime";
import {
  searchMedicationForPurchaseOrder,
  getAllMedication,
  getBatchNumberByMedicine,
  getBatchNumberByAllMedicine,
  getStoreWise,
  getAllmedicationDataByBatchNumber,
} from "../../../Listfunction";
import Swal from "sweetalert2";
import moment from "moment";
import Select from "react-select";
import AsyncSelect from "react-select/lib/Async";
import { searchMedicationForOrder } from "api/purchaseOrder/PurchaseOrder";
import {
  updatePurchaseRequest,
  getPurchaseRequestById,
  PurchaseRequestMedicationCheck,
} from "../../../api/purchaseRequest/purchaseRequest";
import { getAllStoresByCountryCode } from "api/warehouseInventoryDispatch/warehouseInventoryDispatch";
import CheckAvailablePr from "./CheckAvailablePr";
// import { Stepper } from "react-form-stepper";

const EditPurchaseRequest = (props) => {
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const stores = token.store_id;
  const role = token.role;
  const userId = token.id;
  const WAREHOUSE_STORE_ID = 11;
  const PHARMACY_STORE_ID = 10;

  const _notificationSystem = React.createRef();
  const [selectRequestDate, setSelectRequestDate] = useState("");
  const [enterReference, setEnterReference] = useState("");
  const [storeOptions, setStoreOptions] = useState([]);
  const [store, setStore] = useState([]);
  const [medications, setMedications] = useState([]);
  const [storeIDError, setStoreIDError] = useState(null);
  const [rows, setRows] = useState([]);
  const [userData, setUserData] = useState({ id: null });
  const [userStore_id, getUserStore_id] = useState();
  const [request_by, setRequest_by] = useState("");
  const [currentStatus, setCurrentStatus] = useState("");
  const [openInventoryModal, setOpenInventoryModal] = useState(false);
  const [outOfStockRows, setOutOfStockRows] = useState([]);
  const [id, setId] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [localMedicationData, setLocalMedicationData] = useState([]);
  const [medicationOptions, setMedicationOptions] = useState([]);
  const medIndexRef = useRef([]);
  const medMapRef = useRef({});
  const medSearchCacheRef = useRef({});
  const medSearchRequestSeqRef = useRef(0);
  const loadMedTimerRef = useRef(null);
  const inputRef = useRef(null);
  const batchInputRef = useRef([]);
  const [activePRItems, setActivePRItems] = useState([]);
  const [showPrModal, setShowPrModal] = useState(false);
  const [selectedPrItems, setSelectedPrItems] = useState([]);
  const [getStore, setGetStore] = useState("");
  const [selectStoreWise, setSelectStoreWise] = useState([]);
  const [role17ScannedRows, setRole17ScannedRows] = useState({});

  // Local draft persistence (per Purchase Request). Key will be `editPurchaseRequestDraft:<id>`
  const DRAFT_KEY_BASE = "editPurchaseRequestDraft";
  const draftKey = () => (id ? `${DRAFT_KEY_BASE}:${id}` : null);

  const saveDraft = () => {
    try {
      if (!id) return;
      const draft = {
        selectRequestDate,
        enterReference,
        store,
        rows,
        request_by,
        currentStatus,
        // timestamp to help determine recency when debugging/merging
        lastModified: Date.now(),
      };
      localStorage.setItem(draftKey(), JSON.stringify(draft));
    } catch (e) {}
  };
  useEffect(() => {
    getStoreList();
    getUser();
    fetchAllStores();
    try {
      handleGetAllMedication();
    } catch (e) {
      // ignore errors during preload
    }
    const id = window.location.pathname.split("EditPurchaseRequest/")[1];
    setId(id);

    // Try to load a local draft for this Purchase Request. If a draft exists and contains
    // rows, prefer it and skip calling getPurchaseRequestById entirely.
    let draft = null;
    try {
      const key = `${DRAFT_KEY_BASE}:${id}`;
      const raw = localStorage.getItem(key);
      if (raw) draft = JSON.parse(raw);
    } catch (e) {
      console.warn("Failed to read edit Purchase Request draft:", e);
    }
    if (
      role !== 17 &&
      draft &&
      Array.isArray(draft.rows) &&
      draft.rows.length > 0
    ) {
      // load saved draft into state and skip server fetch
      if (draft.selectRequestDate)
        setSelectRequestDate(draft.selectRequestDate);
      if (draft.enterReference) setEnterReference(draft.enterReference);
      if (draft.store) setStore(draft.store);
      if (draft.store) setGetStore(draft.store);
      if (draft.request_by) setRequest_by(userId);
      if (draft.currentStatus) setCurrentStatus(draft.currentStatus);

      const refreshDraftRows = async () => {
        const draftRows = Array.isArray(draft.rows) ? draft.rows : [];
        if (!draftRows.length) {
          setRows([]);
          return;
        }

        const selectedStoreId =
          draft && draft.store && draft.store.value
            ? Number(draft.store.value)
            : Number(stores || 0);

        const hydratedDraftRows = await Promise.all(
          draftRows.map(async (row) => {
            const medicationId = Number(
              row && row.selectedOption && row.selectedOption.value
                ? row.selectedOption.value
                : 0,
            );
            const batchNo = String(
              row && row.batch_no ? row.batch_no : "",
            ).trim();

            if (!medicationId) {
              return row;
            }

            let warehouseStockFromApi = Number(
              row && row.selectedOption && row.selectedOption.qty
                ? row.selectedOption.qty
                : 0,
            );
            let pharmacyStockFromApi = Number(
              row && row.availableStock ? row.availableStock : 0,
            );

            try {
              const batchRes = await getAllmedicationDataByBatchNumber(
                obj,
                batchNo,
                medicationId,
              );

              const batchList =
                batchRes && batchRes.data && Array.isArray(batchRes.data.data)
                  ? batchRes.data.data
                  : [];

              const storeFiltered = selectedStoreId
                ? batchList.filter(
                    (entry) =>
                      Number(entry.store_id) === Number(selectedStoreId),
                  )
                : batchList;

              const matchedBatch =
                (batchNo
                  ? storeFiltered.find(
                      (entry) =>
                        String(
                          entry && entry.batch_no ? entry.batch_no : "",
                        ).toLowerCase() === batchNo.toLowerCase(),
                    )
                  : null) ||
                storeFiltered[0] ||
                batchList[0] ||
                null;

              if (matchedBatch) {
                const storeWiseMedications = Array.isArray(
                  matchedBatch.store_wise_medication,
                )
                  ? matchedBatch.store_wise_medication
                  : Array.isArray(matchedBatch.store_medication_all)
                    ? matchedBatch.store_medication_all
                    : [];
                const resolvedStocks = resolveStoreWiseStocks(
                  storeWiseMedications,
                  WAREHOUSE_STORE_ID,
                  PHARMACY_STORE_ID,
                  matchedBatch.quantity,
                );

                warehouseStockFromApi = resolvedStocks.warehouseQty;
                pharmacyStockFromApi = resolvedStocks.pharmacyQty;
              }
            } catch (e) {
              console.warn("Failed to hydrate draft row stock:", e);
            }

            return {
              ...row,
              selectedOption: {
                ...(row && row.selectedOption ? row.selectedOption : {}),
                value: medicationId,
                qty: Number(warehouseStockFromApi || 0),
              },
              availableQty: Number(warehouseStockFromApi || 0),
              availableStock: Number(pharmacyStockFromApi || 0),
            };
          }),
        );

        setRows(hydratedDraftRows);
        onChangeMedicineCheck(hydratedDraftRows);
      };

      refreshDraftRows();
    } else {
      // No local draft with items; fetch server data as before
      getPurchaseRequestById(obj, id).then(async (res) => {
        if (res && res.data) {
          const data = res.data;
          setSelectRequestDate(data.request_date);
          setCurrentStatus(data.status);
          setEnterReference(data.reference);
          setStore(
            data.store
              ? { value: data.store.id, label: data.store.name }
              : null,
          );
          if (data.store && data.store.id) {
            setGetStore({ value: data.store.id, label: data.store.name });
          }
          setRequest_by(data.request_by_id);
          if (Array.isArray(data.request_items)) {
            const selectedStoreId = data.store
              ? Number(data.store.id)
              : Number(stores || 0);

            const updatedRows = await Promise.all(
              res.data.request_items.map(async (item) => {
                let warehouseStockFromApi = 0;
                let pharmacyStockFromApi = 0;
                try {
                  const medicationId = Number(
                    item.medication_id || item.id || 0,
                  );
                  const batchNo = String(
                    item.batch_no || item.batch || "",
                  ).trim();

                  if (medicationId) {
                    const batchRes = await getAllmedicationDataByBatchNumber(
                      obj,
                      batchNo,
                      medicationId,
                    );

                    const batchList =
                      batchRes &&
                      batchRes.data &&
                      Array.isArray(batchRes.data.data)
                        ? batchRes.data.data
                        : [];

                    const storeFiltered = selectedStoreId
                      ? batchList.filter(
                          (entry) =>
                            Number(entry.store_id) === Number(selectedStoreId),
                        )
                      : batchList;

                    const matchedBatch =
                      (batchNo
                        ? storeFiltered.find(
                            (entry) =>
                              String(
                                entry && entry.batch_no ? entry.batch_no : "",
                              ).toLowerCase() === batchNo.toLowerCase(),
                          )
                        : null) ||
                      storeFiltered[0] ||
                      batchList[0] ||
                      null;

                    if (matchedBatch) {
                      const storeWiseMedications = Array.isArray(
                        matchedBatch.store_wise_medication,
                      )
                        ? matchedBatch.store_wise_medication
                        : Array.isArray(matchedBatch.store_medication_all)
                          ? matchedBatch.store_medication_all
                          : [];
                      const resolvedStocks = resolveStoreWiseStocks(
                        storeWiseMedications,
                        WAREHOUSE_STORE_ID,
                        PHARMACY_STORE_ID,
                        matchedBatch.quantity,
                      );

                      warehouseStockFromApi = resolvedStocks.warehouseQty;
                      pharmacyStockFromApi = resolvedStocks.pharmacyQty;
                    }
                  }
                } catch (e) {
                  console.warn("Failed to fetch available stock:", e);
                }

                const medicationId = Number(item.medication_id || item.id || 0);
                return {
                  selectedOption: {
                    value: medicationId,
                    label: `${item.name} (${item.item_code})`,
                    data: item,
                    qty: Number(warehouseStockFromApi || 0),
                  },
                  batch_no: item.batch_no || item.batch || "",
                  qty: item.quantity || "",
                  availableQty: Number(warehouseStockFromApi || 0),
                  availableStock: Number(pharmacyStockFromApi || 0),
                };
              }),
            );
            setRows(updatedRows);
            onChangeMedicineCheck(updatedRows);
          } else {
            setRows([]);
          }
        }
      });
    }
  }, []);

  // Autosave draft whenever main form state changes (throttle not implemented)
  useEffect(() => {
    saveDraft();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectRequestDate,
    enterReference,
    store,
    rows,
    request_by,
    currentStatus,
  ]);

  const getUser = () => {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      const user = JSON.parse(userStr);
      setUserData({ id: user.id });
      getUserStore_id(user.store_id);
    }
  };
  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        selectedOption: null,
        medications: [],
        availableStock: "0",
        qty: "1",
      },
    ]);
  };
  const getStoreList = () => {
    getStoreWise(token.country_code, obj).then((res) => {
      const store = res.data || [];
      const storeLists = store.map((store) => ({
        value: store.id,
        label: store.name,
      }));
      console.log(storeLists, "storeLists");
      setSelectStoreWise(storeLists);

      const flashWarehouseDefault =
        storeLists.find((item) => Number(item.value) === 11) ||
        storeLists.find((item) =>
          String(item.label || "")
            .toLowerCase()
            .includes("flash warehouse"),
        ) ||
        null;

      if (!getStore && flashWarehouseDefault) {
        setGetStore(flashWarehouseDefault);
      }
    });
  };
  const fetchAllStores = async () => {
    const countryCode = "LK";
    try {
      const response = await getAllStoresByCountryCode(countryCode, obj);
      const stores = response.data.map((store) => {
        return {
          value: store.id,
          label: store.name,
        };
      });
      setStoreOptions(stores);
    } catch (error) {
      console.error("Error fetching stores:", error);
      return [];
    }
  };
  const handleViewPr = (medicationId) => {
    if (!medicationId) return;
    const selectedRow = rows.find(
      (row) => row.selectedOption && row.selectedOption.value === medicationId,
    );
    const medicineName =
      (selectedRow.selectedOption && selectedRow.selectedOption.label) || "—";
    const filteredItems = activePRItems
      .filter(
        (item) =>
          Number(item.medication_id) === Number(medicationId) &&
          Number(item.purchase_request_id) !== Number(id),
      )
      .map((item) => ({
        ...item,
        medicine_name: medicineName,
      }));

    setSelectedPrItems(filteredItems);
    setShowPrModal(true);
  };
  const onChangeMedicineCheck = (rowsData) => {
    const medicationsPayload = rowsData
      .filter((row) => row && row.selectedOption && row.selectedOption.value)
      .map((row) => ({
        id: row.selectedOption.value,
      }));
    const mediId = {
      medications: medicationsPayload,
    };
    PurchaseRequestMedicationCheck(obj, mediId)
      .then((response) => {
        const items = (response.data && response.data.items) || [];
        setActivePRItems(items);
      })
      .catch((error) => {
        console.error("Failed to fetch active PR items:", error);
        setActivePRItems([]);
      });
  };
  const getPurchaseRequestIds = (medicationId) => {
    if (!medicationId || !activePRItems || !id) return [];
    return activePRItems
      .filter(
        (item) =>
          Number(item.medication_id) === Number(medicationId) &&
          Number(item.purchase_request_id) !== Number(id),
      )
      .map((item) => item.purchase_request_id);
  };

  const resolveStoreWiseStocks = (
    storeWiseMedications,
    preferredWarehouseStoreId,
    preferredPharmacyStoreId,
    fallbackQty = 0,
  ) => {
    const list = Array.isArray(storeWiseMedications)
      ? storeWiseMedications
      : [];

    const findByStoreId = (storeId) =>
      storeId
        ? list.find((entry) => Number(entry.store_id) === Number(storeId))
        : null;

    const findByTypeOrName = (expectedType) =>
      list.find((entry) => {
        const type = String(
          entry && entry.pharmacies && entry.pharmacies.type
            ? entry.pharmacies.type
            : "",
        ).toLowerCase();
        const name = String(
          entry && entry.pharmacies && entry.pharmacies.name
            ? entry.pharmacies.name
            : "",
        ).toLowerCase();
        return type === expectedType || name.includes(expectedType);
      }) || null;

    const warehouseEntry =
      findByStoreId(preferredWarehouseStoreId) ||
      findByTypeOrName("warehouse") ||
      (list.length === 1 ? list[0] : null);

    const pharmacyEntry =
      findByStoreId(preferredPharmacyStoreId) || findByTypeOrName("pharmacy");

    return {
      warehouseQty: warehouseEntry
        ? Number(warehouseEntry.quantity || 0)
        : Number(fallbackQty || 0),
      pharmacyQty: pharmacyEntry ? Number(pharmacyEntry.quantity || 0) : 0,
    };
  };

  const handleRemoveRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
    setRole17ScannedRows((prev) => {
      const next = {};
      Object.keys(prev || {}).forEach((key) => {
        const rowIndex = Number(key);
        if (rowIndex < index) next[rowIndex] = prev[key];
        if (rowIndex > index) next[rowIndex - 1] = prev[key];
      });
      return next;
    });
  };

  const handleRole17ChildQtyChange = (parentIndex, childIndex, value) => {
    setRole17ScannedRows((prev) => {
      const children = Array.isArray(prev[parentIndex])
        ? [...prev[parentIndex]]
        : [];
      if (!children[childIndex]) return prev;
      children[childIndex] = {
        ...children[childIndex],
        qty: value,
        touched: true,
      };
      return {
        ...prev,
        [parentIndex]: children,
      };
    });
  };

  const handleRole17ChildQtyBlur = (parentIndex, childIndex, value) => {
    if (value === "" || value === null || value === undefined) {
      setRole17ScannedRows((prev) => {
        const children = Array.isArray(prev[parentIndex])
          ? [...prev[parentIndex]]
          : [];
        if (!children[childIndex]) return prev;
        children[childIndex] = {
          ...children[childIndex],
          qty: "",
          touched: true,
        };
        return {
          ...prev,
          [parentIndex]: children,
        };
      });
      return;
    }

    let nextValue = parseInt(value, 10);
    if (isNaN(nextValue) || nextValue < 1) nextValue = 1;
    setRole17ScannedRows((prev) => {
      const children = Array.isArray(prev[parentIndex])
        ? [...prev[parentIndex]]
        : [];
      if (!children[childIndex]) return prev;
      children[childIndex] = {
        ...children[childIndex],
        qty: String(nextValue),
        touched: true,
      };
      return {
        ...prev,
        [parentIndex]: children,
      };
    });
  };

  const handleRole17ChildRemove = (parentIndex, childIndex) => {
    setRole17ScannedRows((prev) => {
      const children = Array.isArray(prev[parentIndex])
        ? [...prev[parentIndex]]
        : [];
      if (!children[childIndex]) return prev;
      children.splice(childIndex, 1);
      return {
        ...prev,
        [parentIndex]: children,
      };
    });
  };
  // Build a simple phonetic code for loose matching (used by buildMedIndex)
  const soundex = (str) => {
    if (!str) return "";
    const s = str.toUpperCase().replace(/[^A-Z]/g, "");
    if (s.length === 0) return "";
    const first = s[0];
    const mapping = {
      B: "1",
      F: "1",
      P: "1",
      V: "1",
      C: "2",
      G: "2",
      J: "2",
      K: "2",
      Q: "2",
      S: "2",
      X: "2",
      Z: "2",
      D: "3",
      T: "3",
      L: "4",
      M: "5",
      N: "5",
      R: "6",
    };
    let prev = mapping[first] || "";
    let out = first;
    for (let i = 1; i < s.length && out.length < 4; i++) {
      const ch = s[i];
      const code = mapping[ch] || "0";
      if (code === prev) continue;
      if (code !== "0") {
        out += code;
      }
      prev = code;
    }
    return out.padEnd(4, "0").slice(0, 4);
  };

  const buildMedIndex = (medArray) => {
    try {
      medIndexRef.current = medArray.map((m) => {
        const label = `${m.title || m.name} (${m.item_code})`;
        const labelLower = (label || "").toLowerCase();
        let sdx = "";
        try {
          sdx = soundex(labelLower);
        } catch (e) {
          sdx = "";
        }
        return { value: m.id, label, labelLower, soundex: sdx };
      });
      medIndexRef.current.sort((a, b) =>
        a.labelLower > b.labelLower ? 1 : -1,
      );

      const map = {};
      medArray.forEach((m) => {
        map[m.id] = m;
      });
      medMapRef.current = map;
    } catch (e) {
      medIndexRef.current = [];
      medMapRef.current = {};
    }
  };

  const handleGetAllMedication = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("user"));
      const auth = token ? token.token : null;
      const store = 1; // initial prefetch store
      const response = await getAllMedication(auth, store);
      const mdata = response.data;
      const medicationOptions = mdata.map((medication) => ({
        value: medication.id,
        label: `${medication.title} (${medication.item_code})`,
      }));
      setMedicationOptions(medicationOptions);
      setLocalMedicationData(mdata);
      if (mdata && mdata.length > 0) buildMedIndex(mdata);
    } catch (e) {
      // ignore
    }
  };

  const setInputRef = (el, index) => {
    if (!inputRef.current) inputRef.current = [];
    inputRef.current[index] = el;
  };

  const setBatchInputRef = (el, index) => {
    if (!batchInputRef.current) batchInputRef.current = [];
    batchInputRef.current[index] = el;
  };

  useEffect(() => {
    if (role !== 17) return;
    if (!Array.isArray(rows) || rows.length === 0) return;

    const firstEmptyBatchIndex = rows.findIndex(
      (row) => !String((row && row.batch_no) || "").trim(),
    );
    const targetIndex = firstEmptyBatchIndex >= 0 ? firstEmptyBatchIndex : 0;
    const targetInput =
      batchInputRef.current[targetIndex] || batchInputRef.current[0];

    if (!targetInput) return;

    setTimeout(() => {
      try {
        targetInput.focus();
      } catch (e) {}
    }, 0);
  }, [role, rows.length]);

  const loadMedicationOptions = (inputValue) => {
    if (!inputValue || inputValue.trim().length < 2) return Promise.resolve([]);
    const q = inputValue.trim();
    if (medSearchCacheRef.current[q])
      return Promise.resolve(medSearchCacheRef.current[q]);

    if (
      (!medIndexRef.current || medIndexRef.current.length === 0) &&
      localMedicationData &&
      localMedicationData.length > 0
    ) {
      buildMedIndex(localMedicationData);
    }

    return new Promise((resolve) => {
      if (loadMedTimerRef.current) clearTimeout(loadMedTimerRef.current);
      loadMedTimerRef.current = setTimeout(() => {
        if (medIndexRef.current && medIndexRef.current.length > 0) {
          const lower = q.toLowerCase();
          const results = [];
          const LIMIT = 50;

          for (
            let i = 0;
            i < medIndexRef.current.length && results.length < LIMIT;
            i++
          ) {
            const m = medIndexRef.current[i];
            if (m.labelLower.startsWith(lower)) results.push(m);
          }

          if (results.length < LIMIT) {
            for (
              let i = 0;
              i < medIndexRef.current.length && results.length < LIMIT;
              i++
            ) {
              const m = medIndexRef.current[i];
              if (results.indexOf(m) !== -1) continue;
              if (m.labelLower.includes(lower)) results.push(m);
            }
          }

          if (results.length === 0 && lower.length >= 3) {
            const qSound = soundex(lower);
            for (
              let i = 0;
              i < medIndexRef.current.length && results.length < LIMIT;
              i++
            ) {
              const m = medIndexRef.current[i];
              if (m.soundex && m.soundex === qSound) results.push(m);
            }
          }

          const options = results.map((m) => ({
            value: m.value,
            label: m.label,
          }));
          try {
            const keys = Object.keys(medSearchCacheRef.current);
            if (keys.length > 200) delete medSearchCacheRef.current[keys[0]];
            medSearchCacheRef.current[q] = options;
          } catch (e) {}
          return resolve(options);
        }

        medSearchRequestSeqRef.current++;
        const reqSeq = medSearchRequestSeqRef.current;
        try {
          const token = JSON.parse(localStorage.getItem("user"));
          const auth = token ? token.token : null;
          const store_id = userStore_id;
          const city_id = 1;

          searchMedicationForOrder(q, city_id, 1, auth, store_id)
            .then((res) => {
              if (reqSeq !== medSearchRequestSeqRef.current) return resolve([]);
              const data = (res.data && res.data.data) || [];
              const options = data.map((medication) => ({
                value: Number(medication.id || medication.medication_id),
                label: `${medication.title || medication.name} (${
                  medication.item_code
                })`,
              }));
              try {
                const keys = Object.keys(medSearchCacheRef.current);
                if (keys.length > 200)
                  delete medSearchCacheRef.current[keys[0]];
                medSearchCacheRef.current[q] = options;
              } catch (e) {}
              resolve(options);
            })
            .catch(() => resolve([]));
        } catch (e) {
          resolve([]);
        }
      }, 200);
    });
  };
  const handleInputChange = (inputValue, index) => {
    const updatedRows = [...rows];

    if (inputValue.trim() !== "") {
      searchMedicationForPurchaseOrder(inputValue, obj)
        .then((res) => {
          if (res.success) {
            const selectedIds = rows
              .filter((row, i) => i !== index && row.selectedOption)
              .map((row) => row.selectedOption.value);

            const options = res.data.data
              .filter((med) => !selectedIds.includes(med.id))
              .map((med) => ({
                value: med.id,
                label: `${med.medication_name} (${med.item_code})`,
                data: med,
                availableQty: med.total_quantity - med.total_allocated,
              }));
            updatedRows[index].medications = options;
            setRows(updatedRows);
          }
        })
        .catch((err) => {
          console.error("Error fetching medications", err);
        });
    } else {
      updatedRows[index].medications = [];
      setRows(updatedRows);
    }
  };

  const handleSelectChange = async (
    selectedOption,
    index,
    sourceRows = rows,
  ) => {
    if (!selectedOption) return;

    const selectedStoreId =
      (getStore && getStore.value
        ? Number(getStore.value)
        : store && store.value
          ? Number(store.value)
          : Number(userStore_id || stores || 0)) || null;
    if (!selectedStoreId) {
      setStoreIDError(
        <small className="text-danger">warehouse is required</small>,
      );
      await Swal.fire({
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Please select warehouse first</div>",
        icon: "warning",
        showCloseButton: true,
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }

    const updatedRows = [...sourceRows];
    updatedRows[index] = {
      ...updatedRows[index],
      selectedOption: selectedOption,
    };

    const selectedMedData =
      localMedicationData &&
      localMedicationData.find((med) => med.id === selectedOption.value);

    const currentRow =
      updatedRows && updatedRows[index] ? updatedRows[index] : {};
    const currentBatchNo = currentRow.batch_no
      ? String(currentRow.batch_no).trim()
      : "";
    const selectedMediId =
      currentRow && currentRow.selectedOption && currentRow.selectedOption.value
        ? Number(currentRow.selectedOption.value)
        : Number(selectedOption.value);

    let availableStockFromApi = 0;
    let warehouseStockFromApi = null;
    let pharmacyStockFromApi = 0;
    let matchedBatch = null;
    if (selectedMediId) {
      try {
        const batchRes = await getAllmedicationDataByBatchNumber(
          obj,
          currentBatchNo || "",
          selectedMediId,
        );

        const batchList =
          batchRes && batchRes.data && Array.isArray(batchRes.data.data)
            ? batchRes.data.data
            : [];

        const storeFiltered = selectedStoreId
          ? batchList.filter(
              (item) => Number(item.store_id) === Number(selectedStoreId),
            )
          : batchList;

        matchedBatch =
          (currentBatchNo
            ? storeFiltered.find(
                (item) =>
                  String(item && item.batch_no ? item.batch_no : "") ===
                  currentBatchNo,
              )
            : null) ||
          storeFiltered[0] ||
          batchList[0] ||
          null;

        availableStockFromApi = matchedBatch
          ? Number(matchedBatch.quantity || 0)
          : 0;

        if (matchedBatch) {
          const storeWiseMedications = Array.isArray(
            matchedBatch.store_wise_medication,
          )
            ? matchedBatch.store_wise_medication
            : Array.isArray(matchedBatch.store_medication_all)
              ? matchedBatch.store_medication_all
              : [];

          const resolvedStocks = resolveStoreWiseStocks(
            storeWiseMedications,
            WAREHOUSE_STORE_ID,
            PHARMACY_STORE_ID,
            matchedBatch.quantity,
          );

          warehouseStockFromApi = resolvedStocks.warehouseQty;
          availableStockFromApi = resolvedStocks.warehouseQty;
          pharmacyStockFromApi = resolvedStocks.pharmacyQty;
        }
      } catch (e) {
        console.warn("Failed to fetch available stock:", e);
      }
    }

    const selectedOptionWithQty = {
      ...selectedOption,
      qty:
        warehouseStockFromApi !== null
          ? warehouseStockFromApi
          : selectedOption && selectedOption.qty !== undefined
            ? Number(selectedOption.qty || 0)
            : selectedMedData
              ? availableStockFromApi ||
                selectedMedData.total_quantity - selectedMedData.total_allocated
              : Number(selectedOption.qty || 0),
    };

    const duplicate =
      updatedRows &&
      updatedRows.some(
        (row, i) =>
          i !== index &&
          row.selectedOption &&
          row.selectedOption.value === selectedOption.value,
      );

    if (duplicate) {
      Swal.fire({
        width: " 478px",
        title:
          "<div style='font-size:26px;font-weight: 100;'>This medicine is already selected in another row!</div>",
        icon: "warning",
        showCloseButton: true,
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      setRows((prevRows) => {
        const updatedRows = [...prevRows];
        if (updatedRows[index]) {
          updatedRows[index] = {
            ...updatedRows[index],
            batch_no: "",
          };
        }
        return updatedRows;
      });
      return;
    }

    if (matchedBatch && !currentBatchNo) {
      updatedRows[index].batch_no = matchedBatch.batch_no || "";
    }

    updatedRows[index].selectedOption = selectedOptionWithQty;
    updatedRows[index].availableQty = Number(selectedOptionWithQty.qty || 0);
    // updatedRows[index].selectedOption = {
    //   ...selectedOption,
    //   price: Number(selectedMedData.price),
    // };
    updatedRows[index].availableStock =
      selectedOption && selectedOption.pharmacyStock !== undefined
        ? Number(selectedOption.pharmacyStock || 0)
        : Number(pharmacyStockFromApi || 0);
    setRows(updatedRows);
    onChangeMedicineCheck(updatedRows, selectedMediId);
  };

  const handleQtyChange = (e, index) => {
    const value = e.target.value;
    const updatedRows = [...rows];
    updatedRows[index].qty = value;
    updatedRows[index].touched = true;
    setRows(updatedRows);
  };

  const handleQtyBlur = (e, index) => {
    let value = parseInt(e.target.value, 10);

    if (isNaN(value) || value < 1) {
      value = 1;
    }

    const updatedRows = [...rows];
    updatedRows[index].qty = value.toString();
    setRows(updatedRows);
  };

  const referenceOnChange = (event) => {
    const reference = event.target.value;
    setEnterReference(reference);
  };

  const handleRequestDate = (value) => {
    const requestDate = moment(value).format("YYYY-MM-DD");
    setSelectRequestDate(requestDate);
  };

  const validateRequestDate = (current) => {
    return current.isSameOrAfter(moment(), "day");
  };
  const onSubmit = async () => {
    const hasPreviousPR = rows.some(
      (row) =>
        row.selectedOption &&
        getPurchaseRequestIds(row.selectedOption && row.selectedOption.value)
          .length > 0,
    );
    if (isSubmitting) return;
    let error = false;
    const notification = _notificationSystem.current;

    // const outOfStockItems = rows.filter(
    //   (row) => Number(row.qty) > Number(row.availableQty || 0),
    // );

    // if (outOfStockItems.length > 0 && asProcessing === true) {
    //   setOutOfStockRows(outOfStockItems);
    //   setOpenInventoryModal(true);
    //   return;
    // }
    if (role === 1 || role === 2 || role === 11) {
      if (!store || !store.value) {
        error = true;
        setStoreIDError(
          <small className="text-danger">Store is required</small>,
        );
        return;
      }
    }
    if (rows.length === 0) {
      Swal.fire({
        width: "500px",
        title:
          "<div style='font-size:34px; font-weight:bold;'>No Medicine Added</div>",
        icon: "warning",
        html: "<div style='font-size:15px;'>Please add at least one medicine before submitting.</div>",
        showCloseButton: true,
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }

    const isAnyRowIncomplete = rows.some(
      (row) => !row.selectedOption || !row.selectedOption.value,
    );

    if (isAnyRowIncomplete) {
      Swal.fire({
        width: "478",
        title:
          "<div style='font-size:26px;font-weight: 100;'>Please Enter Proper Medication data!</div>",
        icon: "warning",
        showCloseButton: true,
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }
    if (hasPreviousPR) {
      const result = await Swal.fire({
        width: "520px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Do you want to continue?</div>",
        html: "<div style='font-size:16px;'>Some selected medicines are already included in previous incomplete Refill requests</div>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "<span style='font-size:18px;'>Yes</span>",
        cancelButtonText: "<span style='font-size:18px;'>No</span>",
        allowOutsideClick: false,
        showCloseButton: true,
      });

      if (!result.isConfirmed) {
        return;
      }
    }
    if (error) {
      return;
    }
    setIsSubmitting(true);

    const role17BatchesByMedication =
      role === 17
        ? Object.keys(role17ScannedRows || {}).reduce((acc, key) => {
            const children = Array.isArray(role17ScannedRows[key])
              ? role17ScannedRows[key]
              : [];

            const rowMedicationId = Number(
              rows[key] &&
                rows[key].selectedOption &&
                rows[key].selectedOption.value
                ? rows[key].selectedOption.value
                : 0,
            );

            const mapped = children
              .filter((child) => {
                if (!child || !child.batch_no) return false;
                const currentQty = Number(child.qty || 0);
                const originalQty = Number(
                  child.originalQty !== undefined
                    ? child.originalQty
                    : child.availableQty || 0,
                );
                return (
                  currentQty > 0 &&
                  (Boolean(child.touched) || currentQty !== originalQty)
                );
              })
              .map((child) => ({
                medication_id: Number(
                  rowMedicationId || child.medication_id || 0,
                ),
                batch_no: String(child.batch_no || "").trim(),
                expiry_date: child.expiry_date || null,
                quantity: Number(child.qty || child.availableQty || 0),
              }))
              .filter(
                (batch) =>
                  batch.medication_id > 0 &&
                  batch.batch_no &&
                  batch.quantity > 0,
              );

            mapped.forEach((batch) => {
              if (!acc[batch.medication_id]) {
                acc[batch.medication_id] = [];
              }
              acc[batch.medication_id].push({
                batch_no: batch.batch_no,
                expiry_date: batch.expiry_date,
                quantity: batch.quantity,
              });
            });

            return acc;
          }, {})
        : {};

    const medicationsPayload = rows.map((row) => {
      const medicationId = Number(
        row && row.selectedOption ? row.selectedOption.value : 0,
      );

      const medication = {
        id: medicationId || null,
        quantity: parseInt(row.qty),
      };

      if (
        role === 17 &&
        medicationId > 0 &&
        Array.isArray(role17BatchesByMedication[medicationId]) &&
        role17BatchesByMedication[medicationId].length > 0
      ) {
        medication.batches = role17BatchesByMedication[medicationId];
      }

      return medication;
    });

    const tagPayload = {
      reference: enterReference,
      request_date: selectRequestDate,
      status: role == 17 ? 3 : currentStatus,
      request_by: request_by || userId,
      medications: medicationsPayload,
      store_id:
        role === 1 || role === 2 || role === 11 || role === 17
          ? store
            ? store.value
            : null
          : userStore_id,
      type: role === 17 ? "isPurchaseRequest" : "isRefilRequest",
    };

    updatePurchaseRequest(id, obj, tagPayload).then((res) => {
      if (res.data && res.data.success) {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift" />,
          message: (
            <div>
              <b>Purchase Request</b> Updated Successfully.
            </div>
          ),
          level: "success",
          position: "bl",
          autoDismiss: 15,
        });
        // clear draft on successful update
        try {
          const key = draftKey();
          if (key) localStorage.removeItem(key);
        } catch (e) {
          // ignore
        }
        setTimeout(() => {
          props.history.push("/admin/purchase-request");
        }, 3000);
      } else {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift" />,
          message: (
            <div>
              <b>Error: {res.data.message || "All Fields Are Required"}</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
        setIsSubmitting(false);
      }
    });
  };
  const handleBatchInputChange = (event, index) => {
    const value = event.target.value;
    const updatedRows = [...rows];
    updatedRows[index] = {
      ...updatedRows[index],
      batch_no: value,
    };
    setRows(updatedRows);
  };
  const handleBatchNumber = async (batchNo, index) => {
    const value = String(batchNo || "").trim();
    if (!value) return;

    try {
      if (role === 17) {
        const role17Res = await getBatchNumberByAllMedicine(obj, value);
        const medicationData =
          role17Res && role17Res.data && role17Res.data.data
            ? role17Res.data.data
            : null;
        const medicationInfo =
          medicationData && medicationData.medication
            ? medicationData.medication
            : medicationData;
        const medicationBatches = medicationInfo.medication_batches || [];

        const sourceBatches = medicationBatches;

        const storeFilteredBatches = sourceBatches.filter(
          (batch) => Number(batch.store_id) === Number(WAREHOUSE_STORE_ID),
        );

        const filteredBatches = storeFilteredBatches.length
          ? storeFilteredBatches
          : sourceBatches;

        if (!filteredBatches.length) {
          await Swal.fire({
            width: "478px",
            title:
              "<div style='font-size:26px;font-weight:100;'>Batch not found</div>",
            icon: "warning",
            showCloseButton: true,
            confirmButtonText: "<span style='font-size:18px;'>OK</span>",
            allowHtml: true,
          });
          return;
        }

        const updatedRows = [...rows];
        const parentRow = updatedRows[index] || {};
        updatedRows[index] = {
          ...parentRow,
          batch_no: value,
        };
        setRows(updatedRows);

        const childRows = filteredBatches.map((batch) => ({
          id: batch.id,
          medication_id: batch.medication_id,
          medication_title:
            (medicationInfo && medicationInfo.title) ||
            (parentRow &&
            parentRow.selectedOption &&
            parentRow.selectedOption.label
              ? parentRow.selectedOption.label
              : "Medicine"),
          batch_no: batch.batch_no || value,
          expiry_date: batch.expiry_date || "",
          item_code:
            batch.item_code ||
            (medicationInfo && medicationInfo.item_code) ||
            "",
          qty: "",
          originalQty: Number(batch.quantity || 0),
          availableQty: Number(batch.quantity || 0),
          touched: false,
        }));

        setRole17ScannedRows((prev) => ({
          ...prev,
          [index]: childRows,
        }));

        return;
      }

      const selectedStoreId =
        (getStore && getStore.value
          ? Number(getStore.value)
          : store && store.value
            ? Number(store.value)
            : Number(userStore_id || stores || 0)) || null;

      if (!selectedStoreId) {
        await Swal.fire({
          width: "478px",
          title:
            "<div style='font-size:26px;font-weight:100;'>Please select warehouse first</div>",
          icon: "warning",
          showCloseButton: true,
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });
        return;
      }

      const currentRow = rows && rows[index] ? rows[index] : {};
      const currentMedId =
        currentRow &&
        currentRow.selectedOption &&
        currentRow.selectedOption.value
          ? Number(currentRow.selectedOption.value)
          : null;

      let list = [];

      if (currentMedId) {
        const batchByMed = await getAllmedicationDataByBatchNumber(
          obj,
          value,
          currentMedId,
        );
        list =
          batchByMed && batchByMed.data && Array.isArray(batchByMed.data.data)
            ? batchByMed.data.data
            : [];
      }

      if (!list.length) {
        const response = await getBatchNumberByMedicine(obj, value);
        const data = response && response.data ? response.data.data : null;
        list = Array.isArray(data) ? data : [];
      }

      let medicineDetails = null;

      const storeFiltered = selectedStoreId
        ? list.filter(
            (item) => Number(item.store_id) === Number(selectedStoreId),
          )
        : list;

      const medFiltered = currentMedId
        ? storeFiltered.filter(
            (item) => Number(item.medication_id) === Number(currentMedId),
          )
        : storeFiltered;

      medicineDetails =
        medFiltered.find(
          (item) =>
            String(item && item.batch_no ? item.batch_no : "").toLowerCase() ===
            value.toLowerCase(),
        ) ||
        medFiltered[0] ||
        null;

      if (!medicineDetails) {
        await Swal.fire({
          width: "478px",
          title:
            "<div style='font-size:26px;font-weight:100;'>Batch not found</div>",
          icon: "warning",
          showCloseButton: true,
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });

        setRows((prevRows) => {
          const updatedRows = [...prevRows];
          if (updatedRows[index]) {
            updatedRows[index] = {
              ...updatedRows[index],
              batch_no: "",
            };
          }
          return updatedRows;
        });
        return;
      }

      const resolvedMedId = Number(
        medicineDetails.id ||
          medicineDetails.medication_id ||
          currentMedId ||
          0,
      );
      const medFromLocal =
        localMedicationData &&
        localMedicationData.find((medItem) => medItem.id === resolvedMedId);
      const storeMedicationAll = Array.isArray(
        medicineDetails.store_wise_medication,
      )
        ? medicineDetails.store_wise_medication
        : medicineDetails.store_medication_all &&
            medicineDetails.store_medication_all.length > 0
          ? medicineDetails.store_medication_all
          : [];

      const warehouseStoreMedication =
        storeMedicationAll.find(
          (item) => Number(item.store_id) === Number(WAREHOUSE_STORE_ID),
        ) ||
        storeMedicationAll[0] ||
        null;

      const resolvedStocks = resolveStoreWiseStocks(
        storeMedicationAll,
        WAREHOUSE_STORE_ID,
        PHARMACY_STORE_ID,
        medicineDetails.quantity,
      );

      const medTitle =
        (warehouseStoreMedication &&
          warehouseStoreMedication.medication_title) ||
        medicineDetails.title ||
        (medFromLocal &&
          (medFromLocal.title || medFromLocal.medication_name)) ||
        "Medicine";
      const medItemCode =
        (warehouseStoreMedication && warehouseStoreMedication.item_code) ||
        (medFromLocal && medFromLocal.item_code) ||
        medicineDetails.item_code ||
        "";

      const warehouseQty = Number(resolvedStocks.warehouseQty || 0);
      const pharmacyQty = Number(resolvedStocks.pharmacyQty || 0);

      const selectedOption = {
        value: resolvedMedId,
        label: medTitle + " (" + medItemCode + ")",
        batch_no: value,
        qty: warehouseQty,
        pharmacyStock: pharmacyQty,
      };

      if (!selectedOption.value) {
        await Swal.fire({
          width: "478px",
          title:
            "<div style='font-size:26px;font-weight:100;'>Batch not found</div>",
          icon: "warning",
          showCloseButton: true,
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });
        return;
      }

      const updatedRows = [...rows];
      updatedRows[index] = {
        ...updatedRows[index],
        batch_no: value,
        availableQty: warehouseQty,
        availableStock: pharmacyQty,
      };

      await handleSelectChange(selectedOption, index, updatedRows);
    } catch (error) {
      Swal.fire({
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Unable to Find batch</div>",
        icon: "error",
        showCloseButton: true,
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });

      setRows((prevRows) => {
        const updatedRows = [...prevRows];
        if (updatedRows[index]) {
          updatedRows[index] = {
            ...updatedRows[index],
            batch_no: "",
          };
        }
        return updatedRows;
      });

      if (role === 17) {
        setRole17ScannedRows((prev) => ({
          ...prev,
          [index]: [],
        }));
      }
    }
  };

  const handleBatchNoEnter = async (event, index) => {
    if (event.key === "Enter") {
      event.preventDefault();
      await handleBatchNumber(event.target.value, index);
    }
  };

  return (
    <div className="main-content add-purchase-request-content">
      <NotificationSystem ref={_notificationSystem} />
      <Grid fluid>
        {/* <Stepper
          className="customStepper"
          style={{ fontSize: "17px" }}
          steps={[
            {
              label:
                role == 11 && Number(currentStatus) === 1
                  ? "Edit Order"
                  : "Create Order",
            },
            { label: "Update Stock" },
            { label: "Verify Order" },
          ]}
          activeStep={Number(currentStatus) === 2 ? 1 : 0}
        /> */}
        <Card
          tableFullWidth
          content={
            <div
              className="order_topdata_container"
              style={{
                marginBottom: "40px",
                padding: "0 20px",
              }}
            >
              <Row>
                <Col lg={12}>
                  {role === 1 || role === null ? (
                    <>
                      <Row>
                        <Col lg={4}>
                          <FormGroup className="fl_datepicker">
                            <div className="payment_duePicker">
                              <ControlLabel>Request Date</ControlLabel>
                              <Datetime
                                timeFormat={false}
                                dateFormat="YYYY-MM-DD"
                                inputProps={{
                                  placeholder: "Request Date",
                                  disabled: true,
                                }}
                                isValidDate={validateRequestDate}
                                closeOnSelect={true}
                                value={selectRequestDate}
                                onChange={handleRequestDate}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                        <Col lg={4}>
                          <FormGroup>
                            <ControlLabel>Select warehouse</ControlLabel>
                            <Select
                              options={selectStoreWise}
                              value={getStore}
                              onChange={(selectedStore) => (
                                setGetStore(selectedStore || ""),
                                setStoreIDError(null)
                              )}
                              name="store"
                              placeholder="Select warehouse"
                            />
                            {storeIDError}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4}>
                          <FormGroup className="fl_datepicker">
                            <div className="payment_duePicker">
                              <ControlLabel>Reference</ControlLabel>
                              <textarea
                                maxLength={220}
                                className="form-control"
                                rows="4"
                                cols="5"
                                placeholder="Enter Reference"
                                onChange={referenceOnChange}
                                value={enterReference || ""}
                              ></textarea>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <Row>
                      <Col lg={4}>
                        <FormGroup className="fl_datepicker">
                          <div className="payment_duePicker">
                            <ControlLabel>Request Date</ControlLabel>
                            <Datetime
                              timeFormat={false}
                              dateFormat="YYYY-MM-DD"
                              inputProps={{
                                placeholder: "Request Date",
                                disabled: true,
                              }}
                              isValidDate={validateRequestDate}
                              closeOnSelect={true}
                              value={selectRequestDate}
                              onChange={handleRequestDate}
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col lg={4}>
                        <FormGroup className="fl_datepicker">
                          <div className="payment_duePicker">
                            <ControlLabel>Reference</ControlLabel>
                            <textarea
                              maxLength={220}
                              className="form-control"
                              rows="4"
                              cols="5"
                              placeholder="Enter Reference"
                              onChange={referenceOnChange}
                              value={enterReference || ""}
                            ></textarea>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col md={12}>
                      <div className="table-responsive">
                        <Table
                          style={{
                            width: "100%",
                          }}
                        >
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Sr.No</ControlLabel>
                              </th>
                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Batch No</ControlLabel>
                              </th>
                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Medicine Name</ControlLabel>
                              </th>

                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Warehouse Stock</ControlLabel>
                              </th>
                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Quantity</ControlLabel>
                              </th>
                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>
                                  Previous Refill Orders
                                </ControlLabel>
                              </th>

                              <th style={{ textAlign: "center" }}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {rows && rows.length === 0 ? (
                              <tr>
                                <td
                                  colSpan={10}
                                  style={{
                                    textAlign: "center",
                                    fontFamily: "sans-serif",
                                  }}
                                >
                                  No medication added
                                </td>
                              </tr>
                            ) : (
                              rows &&
                              rows.map((row, index) => {
                                const rawRole17Children = Array.isArray(
                                  role17ScannedRows[index],
                                )
                                  ? role17ScannedRows[index]
                                  : [];

                                const role17Children = rawRole17Children
                                  .map((child, originalChildIndex) => ({
                                    child,
                                    originalChildIndex,
                                  }))
                                  .sort((a, b) => {
                                    const dateA = moment(
                                      a && a.child && a.child.expiry_date
                                        ? a.child.expiry_date
                                        : "",
                                      "YYYY-MM-DD",
                                      true,
                                    );
                                    const dateB = moment(
                                      b && b.child && b.child.expiry_date
                                        ? b.child.expiry_date
                                        : "",
                                      "YYYY-MM-DD",
                                      true,
                                    );

                                    const aValid = dateA.isValid();
                                    const bValid = dateB.isValid();
                                    if (!aValid && !bValid) return 0;
                                    if (!aValid) return 1;
                                    if (!bValid) return -1;

                                    return dateA.valueOf() - dateB.valueOf();
                                  });
                                const today = moment().startOf("day");
                                const recentExpiredCandidates = role17Children
                                  .map((entry) => ({
                                    originalChildIndex:
                                      entry.originalChildIndex,
                                    expiryDate: moment(
                                      entry &&
                                        entry.child &&
                                        entry.child.expiry_date
                                        ? entry.child.expiry_date
                                        : "",
                                      "YYYY-MM-DD",
                                      true,
                                    ),
                                  }))
                                  .filter(
                                    (item) =>
                                      item.expiryDate.isValid() &&
                                      item.expiryDate.isBefore(today, "day"),
                                  )
                                  .sort(
                                    (a, b) =>
                                      b.expiryDate.valueOf() -
                                      a.expiryDate.valueOf(),
                                  );
                                const mostRecentExpiredChildIndex =
                                  recentExpiredCandidates.length > 0
                                    ? recentExpiredCandidates[0]
                                        .originalChildIndex
                                    : -1;

                                return (
                                  <React.Fragment key={index}>
                                    <tr>
                                      <td style={{ textAlign: "center" }}>
                                        {index + 1}
                                      </td>
                                      <td>
                                        <FormControl
                                          type="text"
                                          name="batch_no"
                                          placeholder="Scan Batch No"
                                          inputRef={(el) =>
                                            setBatchInputRef(el, index)
                                          }
                                          value={row.batch_no || ""}
                                          onChange={(e) =>
                                            handleBatchInputChange(e, index)
                                          }
                                          onKeyDown={(e) =>
                                            handleBatchNoEnter(e, index)
                                          }
                                          // disabled
                                        />
                                      </td>
                                      <td style={{ width: "30%" }}>
                                        <AsyncSelect
                                          className="react-select primary"
                                          classNamePrefix="react-select"
                                          name="item"
                                          isDisabled={
                                            (role !== 1 &&
                                              [2, 3, 4, 6, 5, 7].includes(
                                                currentStatus,
                                              )) ||
                                            (role === 2 &&
                                              [1, 2, 3, 4, 6, 5, 7].includes(
                                                currentStatus,
                                              )) ||
                                            (role === 1 &&
                                              [3, 5].includes(currentStatus))
                                          }
                                          value={
                                            row.selectedOption &&
                                            row.selectedOption.label &&
                                            row.selectedOption.value
                                              ? row.selectedOption
                                              : null
                                          }
                                          onChange={(value) =>
                                            handleSelectChange(value, index)
                                          }
                                          loadOptions={loadMedicationOptions}
                                          cacheOptions
                                          defaultOptions={false}
                                          ref={(ref) => setInputRef(ref, index)}
                                          placeholder="Medication"
                                          noOptionsMessage={() =>
                                            "Type Item Name or Code or Barcode"
                                          }
                                        />
                                        {row.selectedOption &&
                                          getPurchaseRequestIds(
                                            row.selectedOption.value,
                                          ).length > 0 && (
                                            <p
                                              style={{
                                                marginLeft: "3px",
                                                fontSize: "12px",
                                                color: "red",
                                                marginBottom: "-16px",
                                              }}
                                            >
                                              Item already in previous
                                              incomplete Refill.
                                            </p>
                                          )}
                                      </td>
                                      <td>
                                        <FormControl
                                          isDisabled
                                          placeholder="Available Stock"
                                          value={
                                            Number(
                                              row.availableQty !== undefined
                                                ? row.availableQty
                                                : row.selectedOption &&
                                                    row.selectedOption.qty !==
                                                      undefined
                                                  ? row.selectedOption.qty
                                                  : 0,
                                            ) < 0
                                              ? 0
                                              : Number(
                                                  row.availableQty !== undefined
                                                    ? row.availableQty
                                                    : row.selectedOption &&
                                                        row.selectedOption
                                                          .qty !== undefined
                                                      ? row.selectedOption.qty
                                                      : 0,
                                                )
                                          }
                                          readOnly
                                        />
                                      </td>

                                      <td>
                                        <>
                                          <FormControl
                                            name="qty"
                                            disabled={
                                              (role !== 1 &&
                                                [2, 3, 4, 6, 5, 7].includes(
                                                  currentStatus,
                                                )) ||
                                              (role === 2 &&
                                                [1, 2, 3, 4, 6, 5, 7].includes(
                                                  currentStatus,
                                                )) ||
                                              (role === 1 &&
                                                [3, 5].includes(currentStatus))
                                            }
                                            value={row.qty}
                                            type="number"
                                            min="1"
                                            placeholder="Enter Quantity"
                                            onWheel={(e) => e.target.blur()}
                                            onBlur={(e) =>
                                              handleQtyBlur(e, index)
                                            }
                                            onChange={(e) =>
                                              handleQtyChange(e, index)
                                            }
                                          />
                                          {!!row.selectedOption &&
                                            userStore_id !== 1 &&
                                            userStore_id !== null && (
                                              <p
                                                style={{
                                                  marginLeft: "10px",
                                                  fontSize: "12px",
                                                  color: "green",
                                                  marginBottom: "-16px",
                                                }}
                                              >
                                                Pharmacy Stock{" "}
                                                {row.availableStock}
                                              </p>
                                            )}
                                        </>
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        {row.selectedOption &&
                                          (() => {
                                            const prIds = getPurchaseRequestIds(
                                              row.selectedOption.value,
                                            );
                                            const prCount = prIds.length;
                                            return (
                                              prCount > 0 && (
                                                <OverlayTrigger
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip
                                                      id={`tooltip-pr-${row.selectedOption.value}`}
                                                    >
                                                      Kindly be informed that
                                                      this medicine appears in{" "}
                                                      <strong>{prCount}</strong>{" "}
                                                      previous purchase
                                                      request(s) which remain
                                                      incomplete.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <Button
                                                    size="sm"
                                                    className="btn btn-danger"
                                                    onClick={() =>
                                                      handleViewPr(
                                                        row.selectedOption
                                                          .value,
                                                      )
                                                    }
                                                  >
                                                    <strong>
                                                      View Refil Orders
                                                    </strong>{" "}
                                                    ({prCount})
                                                  </Button>
                                                </OverlayTrigger>
                                              )
                                            );
                                          })()}
                                      </td>

                                      <td style={{ textAlign: "center" }}>
                                        <a
                                          style={{
                                            pointerEvents:
                                              (role !== 1 &&
                                                [2, 3, 4, 6, 5, 7].includes(
                                                  currentStatus,
                                                )) ||
                                              (role === 2 &&
                                                [1, 2, 3, 4, 6, 5, 7].includes(
                                                  currentStatus,
                                                )) ||
                                              (role === 1 &&
                                                [3, 5].includes(currentStatus))
                                                ? "none"
                                                : "auto",

                                            color:
                                              (role !== 1 &&
                                                [2, 3, 4, 6, 5, 7].includes(
                                                  currentStatus,
                                                )) ||
                                              (role === 2 &&
                                                [1, 2, 3, 4, 6, 5, 7].includes(
                                                  currentStatus,
                                                )) ||
                                              (role === 1 &&
                                                [3, 5].includes(currentStatus))
                                                ? "gray"
                                                : "red",
                                            cursor:
                                              (role !== 1 &&
                                                [2, 3, 4, 6, 5, 7].includes(
                                                  currentStatus,
                                                )) ||
                                              (role === 2 &&
                                                [1, 2, 3, 4, 6, 5, 7].includes(
                                                  currentStatus,
                                                )) ||
                                              (role === 1 &&
                                                [3, 5].includes(currentStatus))
                                                ? "not-allowed"
                                                : "pointer",
                                          }}
                                          href="javascript:void(0)"
                                          onClick={() => {
                                            if (
                                              !(
                                                (role !== 1 &&
                                                  [2, 3, 4, 6, 5, 7].includes(
                                                    currentStatus,
                                                  )) ||
                                                (role === 2 &&
                                                  [
                                                    1, 2, 3, 4, 6, 5, 7,
                                                  ].includes(currentStatus)) ||
                                                (role === 1 &&
                                                  [3, 5].includes(
                                                    currentStatus,
                                                  ))
                                              )
                                            ) {
                                              handleRemoveRow(index);
                                            }
                                          }}
                                        >
                                          X
                                        </a>
                                      </td>
                                    </tr>

                                    {role === 17 &&
                                      role17Children.map(
                                        (entry, childIndex) => (
                                          <tr
                                            key={`role17-child-${index}-${entry.originalChildIndex}`}
                                          >
                                            <td style={{ textAlign: "end" }}>
                                              {index + 1}.{childIndex + 1}
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              {entry.child.batch_no || "-"}
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              <div>
                                                {entry.child.medication_title ||
                                                  "-"}
                                              </div>
                                              <small>
                                                Item Code:{" "}
                                                {entry.child.item_code || "-"}
                                              </small>
                                            </td>
                                            <td>
                                              <div>
                                                <span
                                                  style={
                                                    entry.originalChildIndex ===
                                                    mostRecentExpiredChildIndex
                                                      ? {
                                                          color: "#c9302c",
                                                          fontWeight: 700,
                                                        }
                                                      : {}
                                                  }
                                                >
                                                  {entry.child.expiry_date ||
                                                    "-"}
                                                </span>
                                              </div>
                                              <small>
                                                {entry.originalChildIndex ===
                                                mostRecentExpiredChildIndex
                                                  ? "Recently Expired"
                                                  : "Expire Date"}
                                              </small>
                                            </td>
                                            <td>
                                              <FormControl
                                                type="number"
                                                min="1"
                                                value={entry.child.qty}
                                                onWheel={(e) => e.target.blur()}
                                                onChange={(e) =>
                                                  handleRole17ChildQtyChange(
                                                    index,
                                                    entry.originalChildIndex,
                                                    e.target.value,
                                                  )
                                                }
                                                onBlur={(e) =>
                                                  handleRole17ChildQtyBlur(
                                                    index,
                                                    entry.originalChildIndex,
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                              <small
                                                style={{
                                                  display: "block",
                                                  marginTop: "4px",
                                                  color: "green",
                                                  marginLeft: "5px",
                                                }}
                                              >
                                                wareHouse Stock:{" "}
                                                {entry.child.originalQty}
                                              </small>
                                            </td>

                                            <td
                                              style={{
                                                textAlign: "center",
                                                fontSize: "20px",
                                              }}
                                            >
                                              <a
                                                style={{
                                                  color: "red",
                                                  cursor: "pointer",
                                                }}
                                                href="javascript:void(0)"
                                                onClick={() =>
                                                  handleRole17ChildRemove(
                                                    index,
                                                    entry.originalChildIndex,
                                                  )
                                                }
                                              >
                                                <i
                                                  class="fa fa-trash"
                                                  aria-hidden="true"
                                                ></i>
                                              </a>
                                            </td>
                                          </tr>
                                        ),
                                      )}
                                  </React.Fragment>
                                );
                              })
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                    {role !== 2 &&
                      ((role === 1 && currentStatus === 1) ||
                        currentStatus === 2 ||
                        currentStatus === 7 ||
                        currentStatus === 4 ||
                        (role !== 1 && currentStatus === 1)) && (
                        <div style={{ textAlign: "center" }}>
                          <Button
                            className="btn btn-default"
                            style={{ marginTop: "15px" }}
                            onClick={handleAddRow}
                          >
                            <i className="fa fa-plus"></i> Add Medicine
                          </Button>
                        </div>
                      )}
                  </Row>
                </Col>
              </Row>
              <br />
              <Row>
                <Col sm={12}>
                  <Button
                    style={{ marginBottom: "15px" }}
                    onClick={() => onSubmit(false)}
                    disabled={isSubmitting}
                    className="fl_btn_add_order btn-fill btn btn-default"
                    fill="true"
                  >
                    {isSubmitting ? "Updating..." : "Update"}
                  </Button>{" "}
                  {/* &ensp;
                  {((role === 1 || role === 2) && currentStatus === 1) ||
                  currentStatus === 7 ? (
                    <Button
                      style={{
                        marginBottom: "15px",
                        color: "white",
                        cursor: "auto",
                      }}
                      onClick={() => onSubmit(true)}
                      className="badge-fill fl_text_purple"
                      fill
                    >
                      Update As Processing
                    </Button>
                  ) : null} */}
                </Col>
              </Row>
            </div>
          }
        />
        <CheckAvailablePr
          show={showPrModal}
          onHide={() => setShowPrModal(false)}
          items={selectedPrItems}
        />
      </Grid>
      <>
        <Modal
          show={openInventoryModal}
          onHide={() => setOpenInventoryModal(false)}
          bsSize="large"
        >
          <Modal.Header closeButton>
            <Modal.Title>Medicine Out Of Stock</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table responsive>
              <thead>
                <tr>
                  <th>Medicine Name</th>
                  <th>Ordered Qty</th>
                  <th>Available Qty</th>
                </tr>
              </thead>
              <tbody>
                {outOfStockRows.map((row, index) => (
                  <tr key={index}>
                    <td>{row.selectedOption.label}</td>
                    <td>{row.qty}</td>
                    <td>{row.availableQty < 0 ? 0 : row.availableQty}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn-fill btn btn-success" onClick={onSubmit}>
              Submit
            </Button>
            <Button
              className="btn-fill btn btn-info"
              onClick={() => setOpenInventoryModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    </div>
  );
};

export default EditPurchaseRequest;
